import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import "./Footer.scss";

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div className="transFooter">
        <p>
          <FontAwesomeIcon
            icon={["fa", "copyright"]}
            style={{ color: "white" }}
          />
          {"  "}
          {moment().format("YYYY")}{" "}
          <a
            href="https://dmsinetwork.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            DMS International.
          </a>
          {"  "}
          All Rights Reserved.
        </p>
      </div>
    );
  }
}

export default Footer;
